/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PriceUpdateRequestProducts } from '../../models/price-update-request-products';
import { PriceUpdateResponseProducts } from '../../models/price-update-response-products';

export interface UpdatePrice$Params {
  
    /**
     * XML payload containing products and their prices to synchronize
     */
    body: PriceUpdateRequestProducts
}

export function updatePrice(http: HttpClient, rootUrl: string, params: UpdatePrice$Params, context?: HttpContext): Observable<StrictHttpResponse<PriceUpdateResponseProducts>> {
  const rb = new RequestBuilder(rootUrl, updatePrice.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/xml');
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: 'application/xml', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PriceUpdateResponseProducts>;
    })
  );
}

updatePrice.PATH = '/prices';
